import React from "react";
import ReportsCard from "../../components/ReportsCard/ReportsCard";
import styles from "./ReportSectionRenderer.module.css";
import { useDispatch } from "react-redux";
import { openModal } from "../../redux/slices/modalSlice";

const ReportSectionRenderer = ({ reports, search }) => {
  const dispatch = useDispatch();

  const handleClick = (modalKey, config) => {
    if (modalKey) {
      console.log("Opening modal:", modalKey); // ✅ Debug log
      dispatch(openModal({ type: modalKey, config }));

    } else {
      console.warn(
        "No modalKey provided for report:",
        config?.title || "(unknown)"
      );
    }
  };

  const isGrouped = Array.isArray(reports) && reports[0]?.heading;

  if (isGrouped) {
    return (
      <div className={styles.groupedContainer}>
        {reports.map((section, sectionIdx) => (
          <div key={sectionIdx} className={styles.sectionBlock}>
            <h4 className={styles.sectionHeading}>{section.heading}</h4>
            <div className={styles.cardGrid}>
              {section.reports
                .filter((report) => report.title.toLowerCase().includes(search))
                .map((report, index) => (
                  <ReportsCard
                    key={index}
                    title={report.title}
                    description={report.description}
                    onClick={() => handleClick(report.modalKey, report.config)}
                  />
                ))}
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className={styles.cardGrid}>
      {reports
        .filter((report) => report.title.toLowerCase().includes(search))
        .map((report, index) => (
          <ReportsCard
            key={index}
            title={report.title}
            description={report.description}
            onClick={() => handleClick(report.modalKey, report.config)}
          />
        ))}
    </div>
  );
};

export default ReportSectionRenderer;
